<template>
  <v-row>
    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-text-field
        :label="$t('services.search.form.name')"
        v-model.trim="searchParams.name"
        hide-details="auto"
        filled
        type="text"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-text-field
        :label="$t('services.search.form.display-name')"
        v-model.trim="searchParams.displayName"
        hide-details="auto"
        filled
        type="text"
      ></v-text-field>
    </v-col>
    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-autocomplete
        filled
        v-model="searchParams.departmentId"
        hide-details="auto"
        :items="departments"
        item-text="displayText"
        item-value="value"
        clearable
        :label="$t('services.search.form.department')"
      ></v-autocomplete>
    </v-col>
    <v-col cols="12" sm="6" md="4" class="mb-3">
      <v-radio-group
        row
        filled
        v-model="searchParams.isActive"
        hide-details="auto"
        class="mt-0"
      >
        <v-radio
          :label="$t('services.search.form.status.active')"
          :value="true"
        ></v-radio>
        <v-radio
          :label="$t('services.search.form.status.inactive')"
          :value="false"
        ></v-radio>
        <v-radio
          :label="$t('services.search.form.status.all')"
          :value="null"
        ></v-radio>
      </v-radio-group>
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    departments: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    searchParams: {
      handler() {
        this.setSearchParams(this.searchParams);
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters({
      searchParams: "SearchParams/getSearchParams",
    }),
  },
  methods: {
    ...mapActions({
      setSearchParams: "SearchParams/setSearchParams",
    }),
  },
};
</script>
